import { createSlice } from '@reduxjs/toolkit';
import { IEnvironmentSlice } from 'types/environment/IEnvironmentSlice';

export const environmentSlice = createSlice({
  name: 'environmentSlice',
  initialState: { isWindowActive: false },
  reducers: {
    setIsWindowActive(state: IEnvironmentSlice, action: { payload: boolean }) {
      state.isWindowActive = action.payload;
    },
  },
});

export const { setIsWindowActive } = environmentSlice.actions;
